/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Pricing_FreeInputs */

const en_directory_pricing_free = /** @type {(inputs: Directory_Pricing_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free`)
};

const zh_directory_pricing_free = /** @type {(inputs: Directory_Pricing_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费`)
};

/**
* | output |
* | --- |
* | "Free" |
*
* @param {Directory_Pricing_FreeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_pricing_free = /** @type {((inputs?: Directory_Pricing_FreeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Pricing_FreeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_pricing_free(inputs)
	return zh_directory_pricing_free(inputs)
});
export { directory_pricing_free as "directory.pricing.free" }